import { Text } from '@react-three/drei';
import { useGame } from '../board/score-context';

export function DropInstructions() {
  const { isDropped } = useGame();

  if (isDropped) return null;

  return (
    <Text position={[0, 8, 0]} fontSize={0.8} color="#ffffff" anchorX="center" anchorY="middle">
      press space or tap to drop
    </Text>
  );
}
